// Core
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { environment } from '../../../../../environments/environment';

// Third-party Libraries
import dayjs from 'dayjs';

// Font Awesome Module
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faPlus, faEarthAmerica } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-footer-section',
    imports: [FontAwesomeModule, RouterLink],
    templateUrl: './footer-section.html',
    styleUrl: './footer-section.scss',
})
export class FooterSection {

    currentYear = new Date().getFullYear();
    faPlus = faPlus;
    faEarthAmerica = faEarthAmerica;
    dayjs = dayjs;
    environment = environment;

}